import { useState } from "react";
import type { ReactNode } from "react";

import { RailComposerCardContext } from "./railComposerCard";

/** Holds the rail's card visibility — see `RailComposerCardContext`. */
export const RailComposerCardProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [open, setOpen] = useState(false);
  return (
    <RailComposerCardContext.Provider value={{ open, setOpen }}>
      {children}
    </RailComposerCardContext.Provider>
  );
};
